import { useTranslation } from "react-i18next";
import { Reveal } from "@/components/motion/Reveal";
import { useApi } from "@/lib/api/useApi";
import { settingsQuery } from "@/lib/api/queries";

const SOCIAL_CONFIG = [
  {
    label: "WhatsApp",
    key: "whatsapp_url",
    path: "M17.472 14.382c-.022-.08-.124-.22-.282-.361-.157-.14-1.21-.59-1.38-.66-.17-.07-.29-.11-.41-.11-.12 0-.23.07-.37.22-.14.15-.55.69-.67.83-.12.14-.24.16-.46.05-.22-.11-.92-.34-1.75-1.08-.64-.57-1.08-1.28-1.2-1.49-.12-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.13.15-.22.22-.37.07-.15.03-.28-.02-.39-.05-.11-.41-1.09-.57-1.48-.155-.38-.325-.33-.448-.33-.112 0-.24-.01-.37-.01-.13 0-.34.05-.52.25-.18.2-1.02 1-1.02 2.44 0 1.44.81 2.84 1.16 3.32.35.48 2.02 3.09 4.88 4.33.68.29 1.21.47 1.62.6.69.22 1.32.19 1.81.12.55-.08 1.68-.69 1.92-1.36.24-.67.24-1.24.17-1.36-.07-.12-.18-.16-.36-.25zM12.002 2C6.478 2 2 6.478 2 12c0 1.91.53 3.69 1.46 5.22L2 22l4.95-1.3C8.42 21.57 10.15 22 12.002 22c5.522 0 10-4.478 10-10 0-5.522-4.478-10-10-10z",
  },
  {
    label: "Facebook",
    key: "facebook_url",
    path: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
  },
  {
    label: "Instagram",
    key: "instagram_url",
    path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
  },
  {
    label: "TikTok",
    key: "tiktok_url",
    path: "M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
  },
];

export function ContactSection() {
  const { t } = useTranslation();
  const sq = settingsQuery();
  const { data } = useApi(sq.queryKey, sq.queryFn);
  const settings = (data as any)?.settings || data || {};

  // Filter out any social media links that are empty or not provided
  const activeSocials = SOCIAL_CONFIG.map((social) => {
    let url = "";
    if (social.key === "whatsapp_url") {
      url = settings.whatsapp || settings.whatsapp_url || "";
    } else if (social.key === "facebook_url") {
      url = settings.socials?.facebook || settings.facebook_url || "";
    } else if (social.key === "instagram_url") {
      url = settings.socials?.instagram || settings.instagram_url || "";
    } else if (social.key === "tiktok_url") {
      url = settings.socials?.tiktok || settings.tiktok_url || "";
    }
    return { ...social, url };
  }).filter((social) => typeof social.url === "string" && social.url.trim().length > 0);

  return (
    <section id="contact" className="scroll-mt-28 py-section-gap-desktop px-grid-margin bg-surface-container-low border-y border-outline-variant/30">
      <div className="max-w-[1440px] mx-auto text-center">
        <Reveal className="mb-12">
          <h2 className="font-display-lg text-[clamp(22px,6vw,48px)] text-deep-chocolate uppercase tracking-[0.15em] md:tracking-[0.2em] mb-2">
            {t("contact.sectionTitle")}
          </h2>

          <p className="font-label-sm text-label-sm uppercase tracking-[0.2em] text-on-surface-variant">
            {t("contact.sectionSubtitle")}
          </p>
        </Reveal>
        
        {activeSocials.length > 0 ? (
          <div className="flex justify-center items-center gap-6">
            {activeSocials.map((social, index) => {
              return (
                <Reveal
                  key={social.label}
                  as="a"
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  y={32}
                  delay={0.1 + index * 0.12}
                  duration={0.7}
                  className="group w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-md will-change-transform transition-transform duration-300 ease-out hover:-translate-y-1.5"
                >
                  <svg
                    className="w-6 h-6 transition-colors duration-300 ease-out fill-deep-chocolate group-hover:fill-golden-latte"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d={social.path} />
                  </svg>
                </Reveal>
              );
            })}
          </div>
        ) : (
          <p className="text-on-surface-variant/60 text-sm">
            {t("contact.noSocials", { defaultValue: "Follow us on our channels" })}
          </p>
        )}
      </div>
    </section>
  );
}
